<template>
  <div>
    <page-main
      ref="main"
      :tableData="tableData"
      :tablePage="page"
      :loading="loading"
      @reload="reload"
      @exceptionRegister="exceptionRegister"
      @exceptionSee="exceptionSee"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
        @batchSumit="batchSumit"
        @batchExport="batchExport"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
    <vxe-modal
      ref="abnormalRegistration"
      v-model="dialogOption.dialogVisible"
      :title="dialogOption.title"
      destroy-on-close
      type="modal"
      width="900"
      height="570"
    >
      <exception-register :registerData="registerData" @close="close" />
    </vxe-modal>
    <el-dialog
      v-if="visible"
      v-el-dialog-drag
      show-close
      custom-class="feedback-dialog"
      title="异常信息"
      width="1000"
      visible
      :close-on-click-modal="false"
      @close="closeDialog"
    >
      <exception-see :code="code" @reload="reload" />
    </el-dialog>
  </div>
</template>
<script>
import PageMain from './main'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
import ExceptionRegister from '../exc-table/components/exception-register'
import ExceptionSee from './components/exception-see.vue'

export default {
  data() {
    return {
      code: '',
      visible: false,
      usePage: true,
      params: {},
      dialogOption: {
        title: '',
        dialogVisible: false,
      },

      registerData: {},
    }
  },
  components: {
    PageMain,
    PageHeader,
    ExceptionRegister,
    ExceptionSee,
  },
  mixins: [BaseTable],

  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .carriageWaybillDetailListApi({
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    batchSumit() {
      this.$refs.main.batchSumit()
    },
    exceptionRegister(row) {
      if (row) {
        this.dialogOption.title = '异常登记'
        this.registerData = row
        this.dialogOption.dialogVisible = true
      } else {
        return
      }
    },
    exceptionSee(row) {
      this.code = row.dispatchOrderCode
      this.visible = true
    },
    close() {
      this.dialogOption.dialogVisible = false
    },
    closeDialog() {
      this.visible = false
    },
    batchExport() {
      this.$refs.main.batchExport()
    },
  },
}
</script>
